import 'cordova-plugin-purchase';
import { isApprovedWatchDutyTransaction } from './detectIapCollision';

const POLL_INTERVAL_MS = 150;

/**
 * Waits until no approved transactions of ours remain. `finish()` resolving only
 * means the call was made, since the plugin acknowledges asynchronously. Returns
 * the number still outstanding rather than blocking on it.
 */
export const waitForApprovedTransactionsToClear = (
  timeoutMs = 2_000,
): Promise<number> =>
  new Promise<number>((resolve) => {
    const start = Date.now();

    const countRemaining = (): number =>
      CdvPurchase.store.localTransactions.filter(isApprovedWatchDutyTransaction)
        .length;

    const intervalId = setInterval(() => {
      const remaining = countRemaining();
      const expired = Date.now() - start >= timeoutMs;

      if (remaining === 0 || expired) {
        clearInterval(intervalId);
        resolve(remaining);
      }
    }, POLL_INTERVAL_MS);
  });
